import { render } from "./ConfirmationPopup.vue?vue&type=template&id=b5859e68"
import script from "./ConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmationPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__